import {
  DOC_FLOW_COMBINING_ENTITY,
  DOC_FLOW_ENTITY,
  DOC_FLOW_SENDING_ENTITY,
  IDWELL_TO_IDWELL_ENTITY,
  INHABITANT_ENTITY,
  NEWSBOARD_ENTITY,
  RENTAL_LISTING_ENTITY,
  REQUEST_ENTITY,
} from '../../../constants/entity'

export const EntityStatusEntities = {
  DocFlow: DOC_FLOW_ENTITY.single,
  DocFlowCombining: DOC_FLOW_COMBINING_ENTITY.single,
  DocFlowSending: DOC_FLOW_SENDING_ENTITY.single,
  IdwellToIdwell: IDWELL_TO_IDWELL_ENTITY.single,
  Inhabitant: INHABITANT_ENTITY.single,
  Newsboard: NEWSBOARD_ENTITY.single,
  RentalListing: RENTAL_LISTING_ENTITY.single,
  Request: REQUEST_ENTITY.single,
}
